<template>
  <md-dialog v-bind="$attrs" v-on="$listeners" :md-fullscreen="false">
    <md-dialog-content>
      <div class="md-layout downloading">
        <div class="md-layout-item md-size-100 md-centered">{{ title }}</div>
        <div class="md-layout-item md-size-100">
          <loading-spinner v-if="downloading"></loading-spinner>
        </div>
        <div class="md-layout-item md-size-100 md-centered">{{ downloadProgress }}</div>
      </div>
    </md-dialog-content>
  </md-dialog>
</template>

<script>
import LoadingSpinner from "./LoadingSpinner";

export default {
  name      : 'ProgressModel',
  components: {LoadingSpinner},
  props     : {
    title           : {
      type   : String,
      default: null,
    },
    downloadProgress: {
      type   : String,
      default: null,
    },
    downloading     : {
      type   : Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.md-centered {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.downloading {
  min-width: 300px;
}
</style>
